import template from "./sw-customer-detail-base.html.twig";

Shopware.Component.override("sw-customer-detail-base", {
    template,

    watch: {
        customer: {
            immediate: true,
            deep: true,
            handler(customer) {
                if (!customer.extensions.netiAllowIncompleteOrderReminder) {
                    let repositoryFactory = Shopware.Service("repositoryFactory");
                    let repository        = repositoryFactory.create("neti_incomplete_order_reminder_customer_consent");
                    let entity            = repository.create();

                    entity.allowConsent             = false;
                    entity.neverOrderedReminderSent = false;

                    customer.extensions.netiAllowIncompleteOrderReminder = entity;
                }
            }
        }
    }
});
